export const PRODUCT_ID_PATTERN = /^(?:(?:autumn|wedding)-\d{2}|[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})$/i;

export function collectionSlug(value) {
  const letters = { а:"a",б:"b",в:"v",г:"h",ґ:"g",д:"d",е:"e",є:"ye",ж:"zh",з:"z",и:"y",і:"i",ї:"yi",й:"y",к:"k",л:"l",м:"m",н:"n",о:"o",п:"p",р:"r",с:"s",т:"t",у:"u",ф:"f",х:"kh",ц:"ts",ч:"ch",ш:"sh",щ:"shch",ь:"",ю:"yu",я:"ya" };
  return String(value || "").toLowerCase().split("").map((c) => letters[c] ?? c).join("").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 80).replace(/-$/, "");
}

export function collectionText(collection, field, language = "uk") {
  return language === "en" && collection?.[field + "En"] ? collection[field + "En"] : collection?.[field] || "";
}
